import React from "react";
// material-ui components
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
// @material-ui/icons
import Close from "@material-ui/icons/Close";
// core components
import Button from "components/CustomButtons/Button";

import SweetAlert from "react-bootstrap-sweetalert";

import * as Yup from "yup";
import axios from "axios";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { withRouter } from "react-router-dom";
import { Divider, Typography } from "@material-ui/core";

import alertStyles from "assets/jss/elite-feats-cms/views/sweetAlertStyle";
import EditLoading from "./EditGroupLoading";
import { useTranslation } from "react-i18next";
const styles = { ...alertStyles };
const useStyles = makeStyles(styles);

const TField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#2b8cc6",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#3c9778",
    },
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#2b8cc6",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#2b8cc6",
      },
    },
  },
})(TextField);

interface EditGroupModalProps {
  edit: { name: string; description: string };
  modal: boolean;
  openModal: (open: boolean) => void;
  setGroupsAdded: (value: number) => void;
  setReloadTable: (value: number) => void;
}

export default function Modal(props: EditGroupModalProps): React.ReactElement {
  const { t } = useTranslation();
  const classes = useStyles();
  const [alert, setAlert] = React.useState<React.ReactElement | null>(null);
  const [open, setOpen] = React.useState(false);
  const [initialValues, setInitial] = React.useState({
    name: "",
    description: "",
  });

  React.useEffect(() => {
    setInitial({
      name: props.edit.name,
      description: props.edit.description,
    });
  }, [props.edit]);
  const hideAlert = (loc?: string) => {
    if (loc === "success") {
      setAlert(null);
    }
    setAlert(null);
  };

  const dangerAlert = () => {
    setAlert(
      <SweetAlert
        danger
        style={{ display: "block", marginTop: "-100px" }}
        title={t("groups:edit.groupNotEdited")}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.danger}
      >
        {t("groups:edit.groupExistsError")}
      </SweetAlert>
    );
  };

  const successAlert = () => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block", marginTop: "-100px" }}
        title={t("groups:edit.groupDetailsUpdated")}
        onConfirm={() => hideAlert("success")}
        onCancel={() => hideAlert("success")}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        {t("groups:edit.editComplete")}
      </SweetAlert>
    );
  };

  const validationSchema = Yup.object({
    name: Yup.string()
      .min(1, t("groups:edit.minOneChar"))
      .required(t("groups:enterGroupName")),
  });

  const handleSubmit = (values: {
    name: string;
    description: string;
    old_name?: string;
  }) => {
    props.openModal(false);
    setOpen(true);
    values["old_name"] = props.edit.name;
    axios
      .post("/api/client/edit-group", values, {
        headers: {
          "auth-token": localStorage.getItem("token"),
        },
      })
      .then((res) => {
        setOpen(false);
        if (res.data === "not edited") {
          dangerAlert();
        } else if (res.data === "edited") {
          props.setGroupsAdded(Math.random());
          props.setReloadTable(Math.random());

          successAlert();
          setInitial({
            name: "",
            description: "",
          });
        }
      });
  };

  return (
    <div>
      <Dialog
        classes={{
          root: classes.center,
          paper: classes.modal,
        }}
        open={props.modal}
        keepMounted
        disableBackdropClick
        onClose={() => props.openModal(false)}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
          style={{ paddingTop: 30 }}
        >
          <Typography style={{ fontWeight: 900, fontSize: 22 }}>
            {t("groups:edit.editDetails")}
          </Typography>
        </DialogTitle>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
          enableReinitialize
        >
          {({ isSubmitting }) => (
            <Form>
              <DialogContent
                id="modal-slide-description"
                className={classes.modalBody}
                style={{ paddingBottom: 20 }}
              >
                <Field
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  margin="normal"
                  required
                  as={TField}
                  id="name"
                  label={t("groups:edit.groupName")}
                  name="name"
                  autoFocus
                  fullWidth
                  helperText={
                    <ErrorMessage
                      component="div"
                      style={{ color: "#c5473f" }}
                      name="name"
                    />
                  }
                />
                <Field
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  margin="normal"
                  as={TField}
                  fullWidth
                  name="description"
                  label={t("groups:edit.description")}
                  id="description"
                  helperText={
                    <ErrorMessage
                      component="div"
                      style={{ color: "#c5473f" }}
                      name="description"
                    />
                  }
                />
              </DialogContent>
              <Divider light style={{ marginBottom: 10, marginTop: 5 }} />
              <DialogActions
                className={
                  classes.modalFooter + " " + classes.modalFooterCenter
                }
                style={{
                  display: "flex",
                  justifyContent: "center",
                  paddingBottom: 20,
                  paddingLeft: 20,
                  paddingRight: 20,
                }}
              >
                <Button
                  round
                  style={{ marginRight: 10 }}
                  onClick={() => {
                    props.openModal(false);
                  }}
                >
                  {t("groups:edit.cancel")}
                </Button>
                <Button
                  round
                  style={{ marginLeft: 10, marginRight: 10 }}
                  type="submit"
                  color="info"
                >
                  {t("groups:edit.update")}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
      <EditLoading open={open} setOpen={setOpen} />
      {alert}
    </div>
  );
}
